/**
 * main-news.js — the page script for the article layout.
 * Referenced by project/app/View/Layouts/head/head-news.ctp.
 *
 * Shares every helper with main.js by importing the same modules. base_neo and
 * faradeed_neo duplicate ~150 lines between their two entry files and need a
 * byte-equality check in the build to stop the copies drifting (they had
 * already drifted). There is nothing to duplicate here.
 *
 * What is article-only: the image gallery, the short-link copy button, the
 * table-of-contents scrollspy and the reading-progress bar. The magazine
 * reader is its own bundle, magazine-reader.js.
 * What is NOT here: the hero slider — no article page has one.
 */
import { mod, ready } from './lib/module.js';
import { setupTheme } from './lib/theme.js';
import { setupDrawer } from './lib/drawer.js';
import { setupSearch } from './lib/search.js';
import { setupReveal } from './lib/reveal.js';
import { setupGallery } from './lib/gallery.js';
import { setupClipboard } from './lib/clipboard.js';
import { setupResponsiveTables } from './lib/tables.js';
import { setupPoll } from './lib/poll.js';
import { setupShare } from './lib/share.js';
import { setupToc } from './lib/toc.js';
import { setupProgress } from './lib/progress.js';
import { setupGallerySliders } from './lib/gallery-slider.js';

mod('theme', setupTheme);

ready(() => {
  mod('drawer', setupDrawer);
  mod('search', setupSearch);
  mod('reveal', setupReveal);
  mod('gallery', setupGallery);
  mod('clipboard', setupClipboard);
  mod('tables', setupResponsiveTables);
  mod('poll', setupPoll);
  mod('share', setupShare);
  mod('toc', setupToc);
  mod('progress', setupProgress);
  mod('gallerySliders', setupGallerySliders);
});
